import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';

import { HoldingClass, ApiQueryParams, ApiHoldingClassResponse } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

import { updateSocietyData } from 'modules/society/redux/updateSocietyData';

type CreateHoldingClassProps = {
  holdingClass: Partial<HoldingClass>;
  showAlert?: boolean;
};

type GetHoldingClassesProps = {
  societyId: string;
  params?: ApiQueryParams;
  includeRanges?: boolean;
  signal?: AbortSignal;
};

type UpdateHoldingClassProps = {
  holdingClassId: string;
  updateHoldingClassData: Partial<HoldingClass>;
};

export const createHoldingClass =
  ({ holdingClass }: CreateHoldingClassProps) =>
  async (dispatch: Dispatch) => {
    const { data } = await axiosV1.post(`/holdingClasses`, holdingClass);

    const decodedData = (await decryptResponse(
      data
    )) as ApiHoldingClassResponse;

    dispatch({
      type: types.CREATE_HOLDING_CLASS,
      holdingClass: decodedData.holdingClass,
    });

    updateSocietyData(decodedData, dispatch);

    return decodedData;
  };

export const getHoldingClasses =
  ({
    societyId,
    params = {},
    includeRanges = false,
    signal,
  }: GetHoldingClassesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get(`/holdingClasses`, {
        params: {
          societyId,
          includeRanges,
          ...params,
        },
        // signal,
      });

      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.GET_HOLDING_CLASSES,
        holdingClasses: decodedData,
      });
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const updateHoldingClass =
  ({ holdingClassId, updateHoldingClassData }: UpdateHoldingClassProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateHoldingClassData };

    const { data } = await axiosV1.put(
      `/holdingClasses/${holdingClassId}`,
      body
    );

    const decodedData = await decryptResponse(data);

    dispatch({
      type: types.UPDATE_HOLDING_CLASS,
      holdingClass: decodedData,
    });
  };
